
import React, { useEffect, useState } from 'react';
import { Col, Container, Image, Row, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import MyAccountSideBar from './MyAccoutSideBar';
import { fetch } from '../../../../utils';
import CryptoJS from "crypto-js";

const OrderHistory = ({ item }) => {
    const [orderHistoryData, setOrderHistoryData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openOrder, setOpenOrder] = useState(null);

    const tokenDataFromLocalStorage = localStorage.getItem("muskan_token_data");
    const parsedTokenData = tokenDataFromLocalStorage
        ? JSON.parse(tokenDataFromLocalStorage)
        : null;

    const getOrderHistoryData = async () => {
        if (!parsedTokenData?.customer_id) {
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(
                '/order/customer',
                'POST',
                { customer_id: parsedTokenData.customer_id },
                null
            );

            const orders = response?.data?.data?.orders || [];

            setOrderHistoryData(
                [...orders].sort(
                    (a, b) =>
                        new Date(b.order_datetime) -
                        new Date(a.order_datetime)
                )
            );
        } catch (error) {
            console.error("Order history error:", error);
            setOrderHistoryData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getOrderHistoryData();
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        return new Date(dateString).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const orderStatusList = [
        { order_status: 1, order_status_name: "Inserted", className: "text-warning" },
        { order_status: 2, order_status_name: "Confirm", className: "text-success" },
        { order_status: 3, order_status_name: "Cancelled", className: "text-danger" },
        { order_status: 4, order_status_name: "Dispatched", className: "text-primary" },
        { order_status: 5, order_status_name: "Delivered", className: "text-success" },
        { order_status: 6, order_status_name: "Amount Mismatch", className: "text-warning" }
    ];

    const getStatus = (status) =>
        orderStatusList.find(item => item.order_status === status) || {
            order_status_name: "Unknown",
            className: "text-secondary"
        };

    const toggleOrder = (id) => {
        setOpenOrder(prev => prev === id ? null : id);
    };

    return (
        <>
            <hr />
            <Container>
                <font>Home › My Account › Order History</font>

                <Row className="pt-3">
                    <Col sm={3}>
                        <MyAccountSideBar />
                    </Col>

                    <Col sm={9}>
                  
                 
                        <div className="card">
                            <div className="card-header">       <h6 className="">Orders History</h6></div>
                            <div className="card-body">
                                {loading ? (
                                    <div className="text-center py-5">
                                        <Spinner animation="border" />
                                    </div>
                                ) : orderHistoryData.length > 0 ? (
                                    <div className="order-history">
                                        {orderHistoryData.map((order, index) => {
                                            const orderId = order?.cust_order_id || index;
                                            const isOpen = openOrder === orderId;
                                            const status = getStatus(order?.order_status);
                                            const products = Array.isArray(order?.order_items)
                                                ? order.order_items
                                                : [];

                                            return (
                                                <div className="order-box" key={orderId}>
                                                    <div
                                                        className="order-row"
                                                        onClick={() => toggleOrder(orderId)}
                                                    >
                                                        <div>
                                                            <small>Order</small>
                                                            <strong>{order?.order_no || "-"}</strong>
                                                        </div>

                                                        <div>
                                                            <small>Date</small>
                                                            <span>
                                                                {formatDate(order?.order_datetime)}
                                                            </span>
                                                        </div>

                                                        <div>
                                                            <small>Items</small>
                                                            <strong>
                                                                {products.length} Product
                                                                {products.length !== 1 ? "s" : ""}
                                                            </strong>
                                                        </div>

                                                        <div>
                                                            <small>Amount</small>
                                                            <strong>
                                                                <i className="fa fa-inr me-1"></i>
                                                                {order?.order_amount || "0"}
                                                            </strong>
                                                        </div>

                                                        <div>
                                                            <small>Status</small>
                                                            <span className={status.className}>
                                                                {order?.order_status_name ||
                                                                    status.order_status_name}
                                                            </span>
                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="view-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                toggleOrder(orderId);
                                                            }}
                                                        >
                                                            {isOpen ? "Hide Items" : "View Items"}
                                                            <i
                                                                className={`fa fa-chevron-${isOpen ? "up" : "down"} ms-1`}
                                                            />
                                                        </button>
                                                    </div>

                                                    {isOpen && (
                                                        <div className="products-box">
                                                            <div className="products-title">
                                                                <strong>Order Items</strong>
                                                                <span>
                                                                    {products.length} item
                                                                    {products.length !== 1 ? "s" : ""}
                                                                </span>
                                                            </div>

                                                            {products.length > 0 ? (
                                                                products.map((product, i) => (
                                                                    <div
                                                                        className="product-row"
                                                                        key={
                                                                            product?.product_id ||
                                                                            product?.item_id ||
                                                                            i
                                                                        }
                                                                    >
                                                                        <div className="product-img">
                                                                            <Image
                                                                                src={product?.product_thumbnail}
                                                                                alt={product?.product_name || ""}
                                                                            />
                                                                        </div>

                                                                        <div className="product-info">
                                                                            <strong>
                                                                                {product?.product_name || "Product"}
                                                                            </strong>

                                                                            {product?.attribute_values && (
                                                                                <small>
                                                                                    {product.attribute_values}
                                                                                </small>
                                                                            )}

                                                                            <div className="product-meta">
                                                                                {product?.quantity !== undefined && (
                                                                                    <span>
                                                                                        Qty: <b>{product.quantity}</b>
                                                                                    </span>
                                                                                )}

                                                                                {product?.price !== undefined && (
                                                                                    <span>
                                                                                        Price:
                                                                                        <b>
                                                                                            <i className="fa fa-inr ms-1 me-1" />
                                                                                            {product.price}
                                                                                        </b>
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div className="text-center text-muted py-3">
                                                                    No products found
                                                                </div>
                                                            )}

                                                            <div className="order-details">
                                                                <Link
                                                                    to={`/order/${order?.cust_order_id}/${CryptoJS.SHA256(
                                                                        order?.cust_order_id?.toString()
                                                                    )}`}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    View Full Order Details
                                                                    <i className="fa fa-external-link ms-1" />
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="no-orders">
                                        No order history data found.
                                    </div>
                                )}
                            </div>

                        </div>

                    </Col>
                </Row>
            </Container>

            <style>{`
                .order-box {
                    border: 1px solid #e5e5e5;
                    border-radius: 8px;
                    margin-bottom: 10px;
                    background: #fff;
                    overflow: hidden;
                }

                .order-row {
                    display: grid;
                    grid-template-columns: 1.3fr 1fr .8fr 1fr 1fr 1fr;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 14px;
                    cursor: pointer;
                }

                .order-row:hover {
                    background: #fafafa;
                }

                .order-row > div {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    min-width: 0;
                }

                .order-row small {
                    font-size: 10px;
                    color: #999;
                    text-transform: uppercase;
                }

                .order-row strong,
                .order-row span {
                    font-size: 13px;
                }

                .view-btn {
                    border: 0;
                    background: transparent;
                    color: #0d6efd;
                    font-size: 12px;
                    font-weight: 600;
                    cursor: pointer;
                    white-space: nowrap;
                }

                .products-box {
                    border-top: 1px solid #eee;
                    background: #fafafa;
                    padding: 10px 14px;
                }

                .products-title {
                    display: flex;
                    justify-content: space-between;
                    padding-bottom: 7px;
                    border-bottom: 1px solid #e5e5e5;
                    font-size: 13px;
                }

                .products-title span {
                    color: #888;
                    font-size: 12px;
                }

                .product-row {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 9px 0;
                    border-bottom: 1px solid #eee;
                }

                .product-row:last-of-type {
                    border-bottom: 0;
                }

                .product-img {
                    width: 55px;
                    height: 55px;
                    min-width: 55px;
                    background: #fff;
                    border: 1px solid #e5e5e5;
                    border-radius: 6px;
                    overflow: hidden;
                }

                .product-img img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }

                .product-info {
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                    min-width: 0;
                }

                .product-info strong {
                    font-size: 13px;
                    color: #333;
                }

                .product-info small {
                    color: #888;
                    font-size: 11px;
                }

                .product-meta {
                    display: flex;
                    gap: 18px;
                    font-size: 11px;
                    color: #777;
                }

                .product-meta b {
                    color: #444;
                }

                .order-details {
                    text-align: right;
                    padding-top: 8px;
                }

                .order-details a {
                    font-size: 12px;
                    font-weight: 600;
                    text-decoration: none;
                }

                .order-details a:hover {
                    text-decoration: underline;
                }

                .no-orders {
                    text-align: center;
                    padding: 40px;
                    border: 1px solid #eee;
                    border-radius: 8px;
                    color: #777;
                }

                @media (max-width: 991px) {
                    .order-row {
                        grid-template-columns: repeat(3, 1fr);
                    }

                    .view-btn {
                        text-align: left;
                    }
                }

                @media (max-width: 575px) {
                    .order-row {
                        grid-template-columns: 1fr 1fr;
                        gap: 10px;
                    }

                    .product-meta {
                        flex-wrap: wrap;
                        gap: 8px;
                    }
                }
            `}</style>
        </>
    );
};

export default OrderHistory;

